import * as React from 'react'
import className from 'classnames'
import { useForm } from 'react-hook-form'
import { useRef, useState } from 'react'
import Fade from 'react-reveal/Fade'
import * as style from './form.module.scss'
import ButtonPrimary from '../../common/buttons/ButtonPrimary'
import HiddenScrollItem from '../../common/HiddenScrollItem/HiddenScrollItem'
import Modal from '../../common/Modal/Modal'
import ModalFormSuccess from '../../common/Modal/ModalFormSuccess/ModalFormSuccess'
import { FORM_ERRORS, FORM_PATTERNS } from '../../../validators'

export const encode = (data) =>
  Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&')

const Form = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm()
  const [disableSubmit, setDisableSubmit] = useState(false)
  const [checked, setChecked] = useState(true)
  const form = 'contact'
  const modalRef = useRef()

  const onSubmit = async (data) => {
    setDisableSubmit(true)

    const response = await fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': form,
        ...data,
      }),
    })

    if (response.ok) {
      reset()
      setDisableSubmit(false)
      modalRef.current.openModal()
    }
  }

  return (
    <>
      <Modal ref={modalRef}>
        <ModalFormSuccess refItem={modalRef} />
      </Modal>
      <div className="wrapper">
        <HiddenScrollItem positionData={200} id="contact_form" />
        <Fade bottom cascade>
          <form
            className="sample-form main-form__body"
            name={form}
            method="POST"
            data-netlify="true"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className={className(style.item, style.input)}>
              <label className={style.label} htmlFor="show-all-on-submit-name">
                <input
                  id="show-all-on-submit-name"
                  className={style.input}
                  type="text"
                  name="name"
                  placeholder="Name *"
                  {...register('name', {
                    required: {
                      value: true,
                      message: FORM_ERRORS.REQUIRED,
                    },
                    pattern: {
                      value: FORM_PATTERNS.NAME,
                      message: FORM_ERRORS.NAME,
                    },
                    minLength: {
                      value: 3,
                      message: FORM_ERRORS.MIN_LENGTH(3),
                    },
                    maxLength: {
                      value: 30,
                      message: FORM_ERRORS.MAX_LENGTH(3),
                    },
                  })}
                />
              </label>
              {errors.name && (
                <span className={style.error}>{errors.name.message}</span>
              )}
            </div>
            <div className={className(style.item, style.input)}>
              <label className={style.label} htmlFor="show-all-on-submit-email">
                <input
                  id="show-all-on-submit-email"
                  className={style.input}
                  type="text"
                  name="email"
                  placeholder="Email *"
                  {...register('email', {
                    required: {
                      value: true,
                      message: FORM_ERRORS.REQUIRED,
                    },
                    pattern: {
                      value: FORM_PATTERNS.EMAIL,
                      message: FORM_ERRORS.EMAIL,
                    },
                  })}
                />
              </label>
              {errors.email && (
                <span className={style.error}>{errors.email.message}</span>
              )}
            </div>
            <div className={className(style.item, style.input)}>
              <label className={style.label} htmlFor="show-all-on-submit-phone">
                <input
                  id="show-all-on-submit-phone"
                  className={style.input}
                  type="text"
                  {...register('phone', {
                    maxLength: {
                      value: 30,
                      message: FORM_ERRORS.MAX_LENGTH(30),
                    },
                  })}
                  name="phone"
                  placeholder="Phone or skype"
                />
              </label>
              {errors.phone && (
                <span className={style.error}>{errors.phone.message}</span>
              )}
            </div>
            <div className={className(style.item, style.input)}>
              <label
                className={style.label}
                htmlFor="show-all-on-submit-message"
              >
                <textarea
                  id="show-all-on-submit-message"
                  {...register('message', {
                    maxLength: {
                      value: 200,
                      message: FORM_ERRORS.MAX_LENGTH(200),
                    },
                  })}
                  name="message"
                  placeholder="Message"
                />
              </label>
              {errors.message && (
                <span className={style.error}>{errors.message.message}</span>
              )}
            </div>
            <div className={style.checkboxes}>
              <div className={className(style.item)}>
                <div>
                  <label
                    className={style.policy}
                    htmlFor="show-all-on-submit-check_privacy"
                  >
                    <input
                      id="show-all-on-submit-check_privacy"
                      className={style.input}
                      checked={checked}
                      onClick={() => setChecked(!checked)}
                      {...register('privacy', {
                        required: {
                          value: true,
                          message:
                            'We need your permission to process your personal data',
                        },
                      })}
                      type="checkbox"
                    />
                    I consent to Visartech processing my personal data according
                    to
                    <span className={style.connectAgreement}>
                      <a href="/privacy-policy/" target="_blank">
                        Privacy{' '}
                      </a>
                    </span>
                    <span className={style.connectAgreement}>&amp;</span>
                    <span className={style.connectAgreement}>
                      <a href="/cookie-policy/" target="_blank">
                        Cookie Policies
                      </a>
                    </span>
                    <span className={style.checkmark} />
                  </label>
                </div>
                {errors.privacy && (
                  <span className={style.error}>{errors.privacy.message}</span>
                )}
              </div>
              <div className={className(style.item)}>
                <label
                  className={className(style.policy)}
                  htmlFor="show-all-on-submit-check_nda"
                >
                  <input
                    id="show-all-on-submit-check_nda"
                    className={style.input}
                    type="checkbox"
                    {...register('nda')}
                  />
                  <span className={style.checkmark} />
                  Get NDA
                </label>
              </div>
            </div>
            <div className={className(disableSubmit && style.buttonWrap)}>
              <ButtonPrimary
                btnClass={className(
                  style.submit,
                  disableSubmit && 'button-primary--disabled'
                )}
                isSubmit
              >
                Send Message
              </ButtonPrimary>
            </div>
          </form>
        </Fade>
      </div>
    </>
  )
}

export default Form
